(function(root,factory){
 'use strict';
 if(typeof module==='object'&&module.exports)module.exports=factory();
 else root.NikuyaCartPersistence=factory();
})(globalThis,function(){
 'use strict';
 const pages=new WeakMap();
 function create({root,timeoutMs=5000}={}){
  if(pages.has(root))return pages.get(root);
  const listeners=new Set();let state='PENDING_API',finished=false,timer,finish;
  const ready=new Promise(resolve=>{finish=()=>{if(!finished){finished=true;clearTimeout(timer);resolve(state)}}});
  function evaluate(){
   try{const privacy=root?.Shopify?.customerPrivacy;
    if(typeof privacy?.preferencesProcessingAllowed!=='function')return state=finished?'DENIED':'PENDING_API';
    return state=privacy.preferencesProcessingAllowed()===true?'ALLOWED':'DENIED';
   }catch(_){return state='DENIED'}
  }
  const canPersist=()=>evaluate()==='ALLOWED';
  const changed=()=>{evaluate();if(state!=='PENDING_API')finish();for(const listener of listeners)listener(state==='ALLOWED')};
  root?.document?.addEventListener('visitorConsentCollected',changed);
  const api=Object.freeze({canPersist,ready,status:()=>evaluate(),subscribe(listener){listeners.add(listener);return ()=>listeners.delete(listener)},destroy(){clearTimeout(timer);root?.document?.removeEventListener('visitorConsentCollected',changed);listeners.clear()}});
  pages.set(root,api);
  if(evaluate()!=='PENDING_API')finish();
  else {
   timer=setTimeout(()=>{state='DENIED';finish();changed()},timeoutMs);
   try{if(typeof root?.Shopify?.loadFeatures==='function')root.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{
    if(finished)return;
    if(error){state='DENIED';finish();for(const listener of listeners)listener(false);return}
    evaluate();if(state==='PENDING_API')state='DENIED';finish();changed();
   })}catch(_){state='DENIED';finish()}
  }
  return api;
 }
 return Object.freeze({create});
});
